import React from "react";
import { Link } from "react-router-dom";
import SovereignAnchor from "./SovereignAnchor";
import { BRAND } from "../lib/directorate";

/**
 * Official BUSINESS BOOGIE lockup: Sovereign Anchor + wordmark.
 * Renders gold-accented over the dark background. Wraps in <Link to="/">
 * unless `as="div"` is passed (used inside other links to avoid nesting).
 *
 * (Component name retained as `EigooMark` for import-stability across the
 * codebase. The legal operator is still EIGOO Inc.; only the public wordmark
 * has been rebranded to BUSINESS BOOGIE.)
 */
export default function EigooMark({
    size = "lg", // "sm" | "md" | "lg" | "xl"
    showWord = true,
    sub,
    as = "link",
    to = "/",
    className = "",
    testid = "eigoo-mark",
}) {
    const sizes = {
        sm: { anchor: 22, word: "text-base" },
        md: { anchor: 30, word: "text-lg" },
        lg: { anchor: 36, word: "text-2xl" },
        xl: { anchor: 48, word: "text-3xl" },
    };
    const cfg = sizes[size] || sizes.lg;

    const inner = (
        <>
            <SovereignAnchor
                size={cfg.anchor}
                strokeWidth={6}
                className="text-[hsl(45_85%_68%)] drop-shadow-[0_2px_6px_hsl(40_70%_45%/0.25)]"
            />
            {showWord && (
                <div className="flex flex-col leading-none">
                    <span
                        className={`font-heading ${cfg.word} tracking-tight gold-gradient-text whitespace-nowrap`}
                    >
                        {BRAND.name_upper}
                    </span>
                    {sub && (
                        <span className="text-[10px] uppercase tracking-[0.3em] text-muted-foreground mt-1">
                            {sub}
                        </span>
                    )}
                </div>
            )}
        </>
    );

    const cls = `inline-flex items-center gap-3 ${className}`;
    if (as === "div") {
        return (
            <div className={cls} data-testid={testid}>
                {inner}
            </div>
        );
    }
    return (
        <Link to={to} className={cls} data-testid={testid}>
            {inner}
        </Link>
    );
}
